export const TOUR_PLAYER_STATE_KEY = 'tour_guiado_estado'
export const TOUR_BUILDER_STATE_KEY = 'tour_builder_em_construcao'
export const TOUR_BUILDER_ATIVO_KEY = 'tour_builder_ativo'
export const TOUR_ROTAS_SEM_TOUR_KEY = 'tour_guiado_rotas_sem_tour'
